import { withCompInfo } from '@wix/editor-elements-integrations'
import type { BuilderDefinition, BuilderProps, CreateBuilderPropsParams } from './Builder'
import type { ElementData } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'

export const createBuilderProps = ({
	innerElementsProps,
	compData,
	structure,
	reducedManifest,
}: CreateBuilderPropsParams): BuilderProps => {
	const { wix, elementProps } = innerElementsProps
	const containersData: NonNullable<ElementData['containersData']> =
		reducedManifest?.elementData?.root?.containersData ?? {}

	return {
		elementProps,
		_wrapperProps: {
			componentId: structure?.id,
		},
		wix,
		containersData,
		templateContainers: _.pickBy(containersData, (container) => container.containerType === 'template'),
		...compData?.data,
	}
}

export const props = withCompInfo<BuilderProps, BuilderDefinition>()(
	// @ts-ignore
	['innerElementsProps', 'compData', 'structure', 'reducedManifest'],
	createBuilderProps
)
